import React from 'react'
import { AlertCircle, Divider } from '../utils/icons'
import { Avatar } from 'antd'
import female1 from '../assets/images/twelve.jpg'

function Announcements() {
    return (
        <div className='Announcements_style space-y-5'>
            <div className='flex justify-between items-center'>
                <h1 className='font-semibold text-lg'>Announcements</h1>
                <AlertCircle />
            </div>
            <div className='p-5'>
                <div className='flex gap-3 items-center'>
                    <Avatar size={'large'} shape='square' src={female1} alt='female1' />
                    <div>
                        <h1 className='font-semibold'>Faisal Fahd</h1>
                        <p className='text-xs'>Posted an announcement 2 days ago at 10 am</p>
                    </div>
                </div>
                <div className='my-10 flex justify-center'>
                    <Divider />
                </div>
                <div className='calendar_Style max-h-[300px] overflow-auto'>

                    {[...Array(5)].map((_, i) => {
                        return <div key={i} className='space-y-3 '>
                            <h1 className='font-semibold'>Announcement {i + 1}</h1>
                            <p className='w-[90%]'>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the  1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
                            <div className='flex justify-center'>
                                <Divider />
                            </div>
                        </div>
                    })}
                </div>
            </div>
        </div>
    )
}

export default Announcements